import DTO from './DTO';

class DateRangeDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'start',
        type: String,
        validators: [],
        labelKey: 'zone.time_start',
      },
      {
        name: 'end',
        type: String,
        validators: [],
        labelKey: 'zone.time_end',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {
      start: this.start,
      end: this.end,
    };
  }
}

export default DateRangeDTO;
